import { PEND_FEEDBACK_COUNT } from '../Actions/actionName'

const PendFeedbackCountReducer = (state = [], action) => {
  switch (action.type) {
    case PEND_FEEDBACK_COUNT:
      return action.payload;
    default:
      return state;
  }
};

export default PendFeedbackCountReducer;
